import styled from 'styled-components'

export const Wrapper = styled.div.attrs({
  className:
    'sm:w-desktop-width w-screen h-screen mx-auto relative overflow-y-auto hidden-scroll bg-center bg-no-repeat bg-cover'
})``
